import React from 'react';

interface StepCardProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

const StepCard: React.FC<StepCardProps> = ({ title, subtitle, children }) => {
  return (
    <div>
      <header className="mb-6 sm:mb-9">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-900 tracking-tight">
          {title}
        </h2>
        {subtitle && (
          <p className="mt-1.5 text-sm text-gray-600 leading-relaxed">{subtitle}</p>
        )}
      </header>
      {children}
    </div>
  );
};

export default StepCard;
